import {QuickbetsXFilterAction, QuickbetsXFilterActionTypes, QuickbetsXFilterState} from "../../types/QuickbetX/quickbetXsFilterTypes";

const initialState: QuickbetsXFilterState = {
    quickbetsXFilterData: [],
    quickbetsXFilterDataLoading: false,
    quickbetsXFilterDataError: null,
};

export const quickbetXFilterReducer = (state = initialState, action: QuickbetsXFilterAction): QuickbetsXFilterState => {
    switch (action.type) {
        case QuickbetsXFilterActionTypes.FETCH_QUICKBETS_X_FILTER_DATA:
            return { ...state, quickbetsXFilterDataLoading: true, quickbetsXFilterDataError: null };
        case QuickbetsXFilterActionTypes.FETCH_QUICKBETS_X_DATA_FILTER_SUCCESS:
            return { ...state, quickbetsXFilterDataLoading: false, quickbetsXFilterDataError: null, quickbetsXFilterData: action.payload };
        case QuickbetsXFilterActionTypes.FETCH_QUICKBETS_X_DATA_FILTER_ERROR:
            return { ...state, quickbetsXFilterDataLoading: false, quickbetsXFilterDataError: action.payload };
        default:
            return state;
    }
};
